import { BULK_TYPE } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { bulkActivitySiteCoreKeys } from "../../siteCore/SiteCoreKeys";
import { SUMMARY_CARD_TYPE, SummaryCard } from "../summaryCard/SummaryCard";
import { SummaryWrapper, VerticalDivider } from "./SummaryList.style";

interface SummaryListProps {
  totalCount: number;
  processedCount: number;
  unprocessedCount: number;
  activitiesCount?: number;
  isFromTransferFlow?: boolean;
}

// label value is replace by sitecore when it's available
export const SummaryList = ({
  totalCount,
  processedCount,
  unprocessedCount,
  activitiesCount,
  isFromTransferFlow = false,
}: SummaryListProps) => {
  const { fetchLabel } = useSiteCore();
  const getLabel = (key: string) =>
    fetchLabel(bulkActivitySiteCoreKeys.addBulkActivitySummary, key);

  return (
    <SummaryWrapper>
      <SummaryCard
        type={SUMMARY_CARD_TYPE.total}
        count={totalCount}
        label={getLabel(bulkActivitySiteCoreKeys.totalNumberOfParticipant)}
        bulkType={BULK_TYPE.ACTIVITY}
      />
      <VerticalDivider />
      <SummaryCard
        type={SUMMARY_CARD_TYPE.processed}
        count={processedCount}
        label={getLabel(bulkActivitySiteCoreKeys.participantsProcessed)}
        bulkType={BULK_TYPE.ACTIVITY}
      />
      <VerticalDivider />
      <SummaryCard
        type={SUMMARY_CARD_TYPE.unprocessed}
        count={unprocessedCount}
        label={getLabel(bulkActivitySiteCoreKeys.participantUnprocessed)}
        bulkType={BULK_TYPE.ACTIVITY}
      />
      {!isFromTransferFlow && (
        <>
          <VerticalDivider />
          <SummaryCard
            type={SUMMARY_CARD_TYPE.activities}
            count={activitiesCount ?? 0}
            label={getLabel(bulkActivitySiteCoreKeys.numberOfActivity)}
            bulkType={BULK_TYPE.ACTIVITY}
          />
        </>
      )}
    </SummaryWrapper>
  );
};
